import React, {useContext, useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { CurrentEquipContext } from '../../../context/currentEquip-context';
import { AllEquipsContext } from '../../../context/allEquips-context';
import { SystemVolatileContext } from '../../../context/systemVolatile-context';
import { UsersContext } from '../../../context/users-context';

import DetectorCard from '../../cards/DetectorCard'
import GeneratorCard from '../../cards/GeneratorCard'
import SystemCard from '../../cards/SystemCard'
import OrganAutoCard from '../../cards/OrganAutoCard'
import EquipImageCard from '../../cards/EquipImageCard'
import DicomCard from '../../cards/DicomCard'
import RemoteAccessCard from '../../cards/RemoteAccessCard'
import StandCard from '../../cards/StandCard'
import DosimeterCard from '../../cards/DosimeterCard'
import SoftwareCard from '../../cards/SoftwareCard'
import ImagesCard from '../../cards/ImagesCard'
import NotifyDlg from '../../dialogs/NotifyDlg'
import { CardMedia } from '@material-ui/core';
import * as EquipWorker from '../../../workers/equipWorker';
import { saveAs } from 'file-saver';

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
	},
	column: {
		width: "30%",
		marginRight: "12px",
	},
	wrapperEmptyValue: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "calc(100vh - 64px - 48px)",
	},
	emptyValue: {
		width: "300px",
		height: "300px",
		backgroundColor: "#424242",
		mask: "url('/empty-box.svg')",
	},
}));

export default function SummaryMainTabPanel(props) {
  console.log("render SummaryMainTabPanel");

  const classes = useStyles();
  const [currEquipState, currEquipDispatch] = useContext(CurrentEquipContext);
  const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);
  const [systemVolatileState, systemVolatileDispatch] = useContext(SystemVolatileContext);
  const [usersState, usersDispatch] = useContext(UsersContext);

  const notifyText = currEquipState.remoteaccess?.FtpSendResult?.Item2;
  const equipInfo = currEquipState.equipInfo;
  const equipAlias = currEquipState.locationInfo?.EquipAlias;
  const isEquipConnected = allEquipsState.connectedEquips?.includes(equipInfo);
  const lastSeen = currEquipState.lastSeen;
  const hospital = currEquipState.locationInfo?.HospitalName;
  const address = currEquipState.locationInfo?.HospitalAddress;
  const region = {
    Region: currEquipState.locationInfo?.HospitalZones,
    Timezone: currEquipState.locationInfo?.Timezone,
  };
  const token = usersState.token;

  const [showMsg, setShowMsg] = useState(false);
  const [success, setSuccess] = useState(true);
 
	useEffect(() => {
		if (currEquipState.remoteaccess?.FtpSendResult === undefined)
			return;
		
		if (currEquipState.remoteaccess?.FtpSendResult?.Item1) {
			EquipWorker.GetLogsFromFtp(token,
				currEquipState.remoteaccess?.FtpSendResult?.Item2,
				currEquipState.remoteaccess?.FtpSendResult?.Item3
			).then(
				(res) => {
					if (res === undefined) {
						setSuccess(false);
						throw new Error("Response object is empty");
					}
					if (res.status !== 200) {
						setSuccess(false);
						throw new Error("Response status is not success");
					}
					setSuccess(true);
					res.blob().then((bytes) => {
						let elm = document.createElement("a");
						elm.href = URL.createObjectURL(bytes);
						elm.setAttribute(
							"download",
							currEquipState.remoteaccess?.FtpSendResult?.Item3 ?? "download.zip"
						);
						elm.click();
					});
					setShowMsg(true);					
				}
			).catch((error) => {
				console.log(error);
			})
		} else {
			setSuccess(false);
			setShowMsg(true);
		}
	}, [currEquipState.remoteaccess?.FtpSendResult]);

	useEffect(() => {
		if (!showMsg && currEquipState.remoteaccess?.FtpSendResult?.Item1)
		{
			currEquipDispatch({ type: 'SETREMOTEACCESS', payload: {} }); 
		}
	}, [showMsg]);

  return (
		<>
			{equipInfo ? (
				<div className={classes.root}>
					<div className={classes.column}>
						<EquipImageCard
							equipInfo={
								equipAlias ? `${equipAlias} (${equipInfo})` : equipInfo
							}
							isConnected={isEquipConnected}
							lastSeen={lastSeen}
							hospital={hospital}
							address={address}
							region={region}></EquipImageCard>
						<SystemCard
							system={currEquipState.system}
							volatile={systemVolatileState.currentVolatile}></SystemCard>
					</div>
					<div className={classes.column}>
						<OrganAutoCard
							organAuto={
								isEquipConnected ? currEquipState.organAuto : null
							}></OrganAutoCard>
						<ImagesCard
							images={
								isEquipConnected ? currEquipState.images : null
							}></ImagesCard>
						<GeneratorCard
							generator={
								isEquipConnected ? currEquipState.generator : null
							}></GeneratorCard>
						<DetectorCard
							detectors={isEquipConnected ? currEquipState.detectors : null}
							aecs={currEquipState.aecs}></DetectorCard>
						<StandCard
							stand={
								isEquipConnected ? currEquipState.stand : null
							}></StandCard>
						<DosimeterCard
							dosimeter={
								isEquipConnected ? currEquipState.dosimeter : null
							}></DosimeterCard>
					</div>
					<div className={classes.column}>
						<RemoteAccessCard
							equipInfo={isEquipConnected ? currEquipState.equipInfo : null}
							remoteaccess={currEquipState.remoteaccess}
							token={usersState.token}></RemoteAccessCard>
						<DicomCard
							dicom={
								isEquipConnected ? currEquipState.dicom : null
							}></DicomCard>
						<SoftwareCard
							software={currEquipState.software}
							volatile={systemVolatileState.currentVolatile}></SoftwareCard>
					</div>
					{showMsg ? (
						<NotifyDlg
							ftpGetResult={currEquipState.remoteaccess?.FtpSendResult}
							title="Данные FTP"
							text={
								"Данные посланы " +
								(success
									? "успешно"
									: "с ошибками")
							}
							setShowMsg={setShowMsg}></NotifyDlg>
					) : (
						<></>
					)}
				</div>
			) : (
				<div className={classes.wrapperEmptyValue}>
          <div
            className={classes.emptyValue}
            ></div>
          </div>
			)}
		</>
	);
}